function reboot(args) {
  return "reboot";
}

export { reboot };
